function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $862aa3736b0514bc$exports = {};

$parcel$export($862aa3736b0514bc$exports, "FilesDropzone", function () { return $862aa3736b0514bc$export$6ccd1735166caad9; });
// @ts-check
/**
 * Represents a value that may be of type T, or null.
 *
 * @template T
 * @typedef {T | null} Nullable
 */ // @ts-check
/**
 * Checks if a file is valid based on the accepted file type specifiers.
 *
 * @param {File} file - The File object to validate.
 * @param {string} [acceptedTypeSpecifiers=''] - The accepted file type specifiers.
 * @returns {boolean} - True if the file is valid, false otherwise.
 */ function $38f222170fd4d21a$export$7c47054fed488f80(file, acceptedTypeSpecifiers = "") {
    if (!acceptedTypeSpecifiers) return true;
    const acceptedMimeTypesList = [
        ...new Set(acceptedTypeSpecifiers.split(",").map((v)=>v.trim()).filter(Boolean))
    ];
    const fileMimeType = file.type;
    const baseMimeType = fileMimeType.replace(/\/.*$/, "");
    for (const validType of acceptedMimeTypesList){
        if (validType.charAt(0) === ".") {
            if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
        } else if (/\/\*$/.test(validType)) {
            // Check for mime type that looks like "image/*" or similar.
            if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
        } else {
            if (fileMimeType === validType) return true;
        }
    }
    return false;
}


// @ts-check
/**
 * A map of common file extensions and their associated MIME types.
 */ const $f31161edf38949e9$var$COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jxl",
        "image/jxl"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
const $f31161edf38949e9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
/**
 * Adds a `type` property to the file object if it doesn't have one and the file has an extension.
 * This is needed because Firefox doesn't add a type property to files dragged from the desktop.
 * @bug https://bugzilla.mozilla.org/show_bug.cgi?id=1424689
 *
 * @param {File} file - The file object to add the type property to.
 * @returns {File} - The file object with the type property added.
 */ const $f31161edf38949e9$var$toFileWithMimeType = (file)=>{
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        const extension = (name.split(".").pop() || "").toLowerCase();
        const type = $f31161edf38949e9$var$COMMON_MIME_TYPES.get(extension);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
};
/**
 * Adds a `path` property to the file object if it doesn't have one.
 * If `path` is not provided, the `webkitRelativePath` property of the file will be used
 * or the file's name if `webkitRelativePath` is not available.
 *
 * @param {File} file - The file object to add the path property to.
 * @param {string} [path] - The path to set on the file object.
 * @returns {File} - The file object with the path property added.
 */ const $f31161edf38949e9$var$toFileWithPath = (file, path)=>{
    const fileWithMimeType = $f31161edf38949e9$var$toFileWithMimeType(file);
    // @ts-ignore
    if (typeof fileWithMimeType.path !== "string") {
        const { webkitRelativePath: webkitRelativePath } = file;
        Object.defineProperty(fileWithMimeType, "path", {
            value: typeof path === "string" ? path : webkitRelativePath || file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return fileWithMimeType;
};
/**
 * Wrap `FileSystemDirectoryReader.readEntries` in a promise to make working with read entries easier.
 * https://developer.mozilla.org/docs/Web/API/FileSystemDirectoryReader/readEntries
 *
 * @param {FileSystemDirectoryReader} directoryReader - The directory reader to read entries from.
 * @returns {Promise<FileSystemEntry[]>} - A promise that resolves with an array of `FileSystemEntry` objects.
 */ const $f31161edf38949e9$var$readEntriesPromise = async (directoryReader)=>{
    return await new Promise((resolve, reject)=>{
        directoryReader.readEntries(resolve, reject);
    });
};
/**
 * Read all entries in a directory or sub-directory
 * by calling `readEntries` until it returns an empty array.
 *
 * @param {FileSystemDirectoryReader} directoryReader - The directory reader to read entries from.
 * @returns {Promise<FileSystemEntry[]>} - A promise that resolves with an array of `FileSystemEntry` objects.
 */ const $f31161edf38949e9$var$readAllDirectoryEntries = async (directoryReader)=>{
    const entries = [];
    let readEntries = await $f31161edf38949e9$var$readEntriesPromise(directoryReader);
    while(readEntries.length > 0){
        entries.push(...readEntries);
        readEntries = await $f31161edf38949e9$var$readEntriesPromise(directoryReader);
    }
    return entries;
};
/**
 * Get a `File` object from a `FileSystemFileEntry` object.
 *
 * @param {FileSystemFileEntry} fileEntry - The file entry to get a `File` object from.
 * @returns {Promise<File>} - A promise that resolves with a `File` object.
 */ const $f31161edf38949e9$var$getFileFromFileEntry = (fileEntry)=>{
    return new Promise((resolve, reject)=>{
        fileEntry.file((file)=>resolve($f31161edf38949e9$var$toFileWithPath(file, fileEntry.fullPath)), reject);
    });
};
/**
 * Get an array of `File` objects from a `DataTransferItemList` object.
 *
 * @param {DataTransferItemList} dataTransferItemList - The item list to get an array of `File` objects from.
 * @returns {Promise<File[]>} - A promise that resolves with an array of `File` objects.
 */ const $f31161edf38949e9$var$getFilesFromDataTransferItemList = async (dataTransferItemList)=>{
    const files = [];
    // Chromium browsers read only 100 files at a time as per the spec, so we need to use
    // BFS (Breadth-first search) to traverse the entire directory/file structure.
    // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry#javascript_content
    const queue = [];
    for (const item of dataTransferItemList){
        if (item.kind !== "file") continue;
        // https://developer.mozilla.org/docs/Web/API/DataTransferItem/webkitGetAsEntry
        // This function is implemented as `webkitGetAsEntry()` in non-WebKit browsers
        // including Firefox at this time but it may be renamed to `getAsEntry()` in the future.
        // @ts-ignore
        const entry = item.getAsEntry ? item.getAsEntry() : item.webkitGetAsEntry();
        queue.push(entry);
    }
    while(queue.length > 0){
        const entry = queue.shift();
        if (!entry) continue;
        else if (entry.isFile) {
            const file = await $f31161edf38949e9$var$getFileFromFileEntry(entry);
            if ($f31161edf38949e9$var$FILES_TO_IGNORE.indexOf(file.name) === -1) files.push(file);
        } else if (entry.isDirectory) queue.push(...await $f31161edf38949e9$var$readAllDirectoryEntries(entry.createReader()));
    }
    return files;
};
/**
 * Get an array of `File` objects from a `FileList` object.
 *
 * @param {FileList} fileList - The file list to get an array of `File` objects from.
 * @returns {Promise<File[]>} - A promise that resolves with an array of `File` objects.
 */ const $f31161edf38949e9$var$getFilesFromFileList = async (fileList)=>{
    const files = [];
    for (const file of fileList)if ($f31161edf38949e9$var$FILES_TO_IGNORE.indexOf(file.name) === -1) files.push($f31161edf38949e9$var$toFileWithPath(file));
    return files;
};
const $f31161edf38949e9$export$6d52664cd15c442 = async (evt)=>{
    if (evt.dataTransfer) return evt.dataTransfer.items ? await $f31161edf38949e9$var$getFilesFromDataTransferItemList(evt.dataTransfer.items) : await $f31161edf38949e9$var$getFilesFromFileList(evt.dataTransfer.files);
    return await $f31161edf38949e9$var$getFilesFromFileList(evt.target.files);
};


const $862aa3736b0514bc$var$COMPONENT_NAME = "files-dropzone";
const $862aa3736b0514bc$var$TOO_MANY_FILES = "TOO_MANY_FILES";
const $862aa3736b0514bc$var$FILE_TOO_LARGE = "FILE_TOO_LARGE";
const $862aa3736b0514bc$var$FILE_TOO_SMALL = "FILE_TOO_SMALL";
const $862aa3736b0514bc$var$INVALID_MIME_TYPE = "INVALID_MIME_TYPE";
const $862aa3736b0514bc$var$template = document.createElement("template");
const $862aa3736b0514bc$var$styles = /* css */ `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host {
    --dropzone-border-width: 2px;
    --dropzone-border-style: dashed;
    --dropzone-border-radius: 0.25rem;
    --dropzone-border-color: #6c757d;
    --dropzone-border-color-dragover: #0d6efd;
    --dropzone-border-color-hover: var(--dropzone-border-color-dragover);
    --dropzone-background-color: #ffffff;
    --dropzone-background-color-dragover: #f4f4f5;
    --dropzone-background-color-hover: var(--dropzone-background-color-dragover);
    --dropzone-body-color: #3f3f46;
    --dropzone-body-color-dragover: var(--dropzone-body-color);
    --dropzone-body-color-hover: var(--dropzone-body-color-dragover);
    --dropzone-focus-shadow-rgb: 49,132,253;
    --dropzone-focus-box-shadow: 0 0 0 0.25rem rgba(var(--dropzone-focus-shadow-rgb), 0.5);
    --transition-duration: 0.2s; /* for backwards compatibility */
    --dropzone-transition-duration: var(--transition-duration);

    display: block;
  }

  :host(:not([no-style])) .dropzone {
    border: var(--dropzone-border-width) var(--dropzone-border-style) var(--dropzone-border-color);
    border-radius: var(--dropzone-border-radius);
    padding: 3rem 1rem;
    overflow: hidden;
    background-color: var(--dropzone-background-color);
    color: var(--dropzone-body-color);
    text-align: center;
    cursor: pointer;
    transition: border var(--dropzone-transition-duration) ease-in-out, background-color var(--dropzone-transition-duration) ease-in-out, color var(--dropzone-transition-duration) ease-in-out, box-shadow var(--dropzone-transition-duration) ease-in-out;
  }

  :host(:not([no-style])[disabled]) .dropzone {
    opacity: 0.8;
    cursor: not-allowed;
    user-select: none;
  }

  :host(:not([no-style]):not([disabled])) .dropzone--dragover {
    border-color: var(--dropzone-border-color-dragover);
    background-color: var(--dropzone-background-color-dragover);
    color: var(--dropzone-body-color-dragover);
  }

  :host(:not([no-style]):not([disabled])) .dropzone:focus-visible {
    outline: none;
    box-shadow: var(--dropzone-focus-box-shadow);
  }

  @media (hover: hover) {
    :host(:not([no-style]):not([disabled])) .dropzone:not(.dropzone--dragover):hover {
      border-color: var(--dropzone-border-color-hover);
      background-color: var(--dropzone-background-color-hover);
      color: var(--dropzone-body-color-hover);
    }
  }
`;
$862aa3736b0514bc$var$template.innerHTML = /* html */ `
  <style>
    ${$862aa3736b0514bc$var$styles}
  </style>

  <input type="file" id="file-input" hidden>

  <div part="dropzone" class="dropzone" id="dropzone" tabindex="0" role="button" aria-disabled="false">
    <slot>Drag 'n' drop files here, or click to select files</slot>
  </div>
`;
/**
 * @summary A custom element that allows users to drag and drop files into it.
 * @documentation https://github.com/georapbox/files-dropzone-element
 *
 * @tagname files-dropzone - This is the default tag name, unless overridden by the `defineCustomElement` method.
 *
 * @property {string} accept - A comma-separated list of unique file type specifiers describing file types to allow.
 * @property {boolean} disabled - Determines whether the dropzone is disabled.
 * @property {number} maxFiles - The maximum number of files allowed to be dropped.
 * @property {number} maxSize - The maximum file size allowed in bytes.
 * @property {number} minSize - The minimum file size allowed in bytes.
 * @property {boolean} multiple - Allows multiple files to be dropped.
 * @property {boolean} autoFocus - Automatically focuses the dropzone when it's connected to the DOM.
 * @property {boolean} noStyle - Prevents the dropzone from applying any styling.
 *
 * @attribute {string} accept - Reflects the accept property.
 * @attribute {boolean} disabled - Reflects the disabled property.
 * @attribute {number} max-files - Reflects the maxFiles property.
 * @attribute {number} max-size - Reflects the maxSize property.
 * @attribute {number} min-size - Reflects the minSize property.
 * @attribute {boolean} multiple - Reflects the multiple property.
 * @attribute {boolean} auto-focus - Reflects the autoFocus property.
 * @attribute {boolean} no-style - Reflects the noStyle property.
 *
 * @slot - The default slot content of the dropzone.
 *
 * @csspart dropzone - The dropzone element.
 * @csspart dropzone--dragover - The state of the dropzone when dragging over it.
 *
 * @cssproperty --dropzone-border-width - The border width of the dropzone.
 * @cssproperty --dropzone-border-style - The border style of the dropzone.
 * @cssproperty --dropzone-border-radius - The border radius of the dropzone.
 * @cssproperty --dropzone-border-color - The border color of the dropzone.
 * @cssproperty --dropzone-border-color-dragover - The border color of the dropzone when dragging over it.
 * @cssproperty --dropzone-border-color-hover - The border color of the dropzone when hovering over it.
 * @cssproperty --dropzone-background-color - The background color of the dropzone.
 * @cssproperty --dropzone-background-color-dragover - The background color of the dropzone when dragging over it.
 * @cssproperty --dropzone-background-color-hover - The background color of the dropzone when hovering over it.
 * @cssproperty --dropzone-body-color - The text color of the dropzone.
 * @cssproperty --dropzone-body-color-dragover - The text color of the dropzone when dragging over it.
 * @cssproperty --dropzone-body-color-hover - The text color of the dropzone when hovering over it.
 * @cssproperty --dropzone-focus-shadow-rgb - The RGB value of the dropzone's focus shadow.
 * @cssproperty --dropzone-focus-box-shadow - The box shadow of the dropzone when focused.
 * @cssproperty --dropzone-transition-duration - The transition's duration for the dropzone area.
 *
 * @event files-dropzone-drop - Fired when files are dropped.
 * @event files-dropzone-drop-accepted - Fired when files dropped files are accepted.
 * @event files-dropzone-drop-rejected - Fired when files dropped files are rejected.
 * @event files-dropzone-dragenter - Fired when files are dragged into the dropzone.
 * @event files-dropzone-dragover - Fired when files are dragged over the dropzone.
 * @event files-dropzone-dragleave - Fired when files are dragged out of the dropzone.
 * @event files-dropzone-error - Fired when there is any error in the process of reading dropped files or directories.
 *
 * @method defineCustomElement - Static method. Defines a custom element with the given name.
 * @method openFileDialog - Instance method. Opens the file dialog programmatically.
 */ class $862aa3736b0514bc$export$6ccd1735166caad9 extends HTMLElement {
    /** @type {Nullable<HTMLInputElement>} */ #fileInput = null;
    /** @type {Nullable<HTMLElement>} */ #dropzoneEl = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: "open",
                delegatesFocus: true
            });
            shadowRoot.appendChild($862aa3736b0514bc$var$template.content.cloneNode(true));
        }
        if (this.shadowRoot) {
            this.#fileInput = /** @type {Nullable<HTMLInputElement>} */ this.shadowRoot.getElementById("file-input");
            this.#dropzoneEl = this.shadowRoot.getElementById("dropzone");
        }
    }
    static get observedAttributes() {
        return [
            "accept",
            "disabled",
            "multiple"
        ];
    }
    /**
   * Lifecycle method that is called when attributes are changed, added, removed, or replaced.
   *
   * @param {string} name - The name of the attribute.
   * @param {string} oldValue - The old value of the attribute.
   * @param {string} newValue - The new value of the attribute.
   */ attributeChangedCallback(name, oldValue, newValue) {
        if (name === "accept" && oldValue !== newValue && this.#fileInput) this.#fileInput.accept = this.accept;
        if (name === "disabled" && oldValue !== newValue && this.#fileInput) {
            this.#fileInput.disabled = this.disabled;
            if (this.disabled) {
                this.#dropzoneEl?.removeAttribute("tabindex");
                this.#dropzoneEl?.setAttribute("aria-disabled", "true");
            } else {
                this.#dropzoneEl?.setAttribute("tabindex", "0");
                this.#dropzoneEl?.setAttribute("aria-disabled", "false");
            }
        }
        if (name === "multiple" && oldValue !== newValue && this.#fileInput) this.#fileInput.multiple = this.multiple;
    }
    /**
   * Lifecycle method that is called when the element is added to the DOM.
   */ connectedCallback() {
        this.#upgradeProperty("accept");
        this.#upgradeProperty("disabled");
        this.#upgradeProperty("maxFiles");
        this.#upgradeProperty("maxSize");
        this.#upgradeProperty("minSize");
        this.#upgradeProperty("multiple");
        this.#upgradeProperty("autoFocus");
        this.#upgradeProperty("noStyle");
        this.#fileInput?.addEventListener("change", this.#handleFileInputChange);
        this.#dropzoneEl?.addEventListener("dragenter", this.#handleDragEnter);
        this.#dropzoneEl?.addEventListener("dragover", this.#handleDragOver);
        this.#dropzoneEl?.addEventListener("dragleave", this.#handleDragLeave);
        this.#dropzoneEl?.addEventListener("drop", this.#handleDrop);
        this.#dropzoneEl?.addEventListener("click", this.#handleClick);
        this.#dropzoneEl?.addEventListener("keyup", this.#handleKeyUp);
        this.autoFocus && this.#dropzoneEl?.focus();
    }
    /**
   * Lifecycle method that is called when the element is removed from the DOM.
   */ disconnectedCallback() {
        this.#fileInput?.removeEventListener("change", this.#handleFileInputChange);
        this.#dropzoneEl?.removeEventListener("dragenter", this.#handleDragEnter);
        this.#dropzoneEl?.removeEventListener("dragover", this.#handleDragOver);
        this.#dropzoneEl?.removeEventListener("dragleave", this.#handleDragLeave);
        this.#dropzoneEl?.removeEventListener("drop", this.#handleDrop);
        this.#dropzoneEl?.removeEventListener("click", this.#handleClick);
        this.#dropzoneEl?.removeEventListener("keyup", this.#handleKeyUp);
    }
    /**
   * @type {string} - A comma-separated list of unique file type specifiers describing file types to allow.
   * @attribute accept - Reflects the accept property.
   */ get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(value) {
        this.setAttribute("accept", value != null ? value.toString() : value);
    }
    /**
   * @type {boolean} - Determines whether the dropzone is disabled.
   * @default false
   * @attribute disabled - Reflects the disabled property.
   */ get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(value) {
        this.toggleAttribute("disabled", !!value);
    }
    /**
   * @type {number} - The maximum number of files allowed to be dropped.
   * @default Infinity
   * @attribute max-files - Reflects the maxFiles property.
   */ get maxFiles() {
        const num = Number(this.getAttribute("max-files")) || 0;
        if (num <= 0) return Infinity;
        return Math.floor(Math.abs(num));
    }
    set maxFiles(value) {
        this.setAttribute("max-files", value != null ? value.toString() : value);
    }
    /**
   * @type {number} - The maximum file size allowed in bytes.
   * @default Infinity
   * @attribute max-size - Reflects the maxSize property.
   */ get maxSize() {
        const value = this.getAttribute("max-size");
        if (value === null) return Infinity;
        const num = Number(value);
        return Number.isNaN(num) ? Infinity : num;
    }
    set maxSize(value) {
        this.setAttribute("max-size", value != null ? value.toString() : value);
    }
    /**
   * @type {number} - The minimum file size allowed in bytes.
   * @default 0
   * @attribute min-size - Reflects the minSize property.
   */ get minSize() {
        const value = this.getAttribute("min-size");
        if (value === null) return 0;
        const num = Number(value);
        return Number.isNaN(num) ? 0 : num;
    }
    set minSize(value) {
        this.setAttribute("min-size", value != null ? value.toString() : value);
    }
    /**
   * @type {boolean} - Allows multiple files to be dropped.
   * @default false
   * @attribute multiple - Reflects the multiple property.
   */ get multiple() {
        return this.hasAttribute("multiple");
    }
    set multiple(value) {
        this.toggleAttribute("multiple", !!value);
    }
    /**
   * @type {boolean} - Automatically focuses the dropzone when it's connected to the DOM.
   * @default false
   * @attribute auto-focus - Reflects the autoFocus property.
   */ get autoFocus() {
        return this.hasAttribute("auto-focus");
    }
    set autoFocus(value) {
        this.toggleAttribute("auto-focus", !!value);
    }
    /**
   * @type {boolean} - Prevents the dropzone from applying any styling.
   * @default false
   * @attribute no-style - Reflects the noStyle property.
   */ get noStyle() {
        return this.hasAttribute("no-style");
    }
    set noStyle(value) {
        this.toggleAttribute("no-style", !!value);
    }
    /**
   * Handles the change event of the file input.
   *
   * @param {*} evt - The event object.
   */ #handleFileInputChange = async (evt)=>{
        try {
            this.#handleFilesSelect(await (0, $f31161edf38949e9$export$6d52664cd15c442)(evt));
        } catch (error) {
            this.dispatchEvent(new CustomEvent(`${$862aa3736b0514bc$var$COMPONENT_NAME}-error`, {
                bubbles: true,
                composed: true,
                detail: {
                    error: error
                }
            }));
        }
    };
    /**
   * Handles the dragenter event of the dropzone.
   */ #handleDragEnter = ()=>{
        if (this.disabled) return;
        this.dispatchEvent(new Event(`${$862aa3736b0514bc$var$COMPONENT_NAME}-dragenter`, {
            bubbles: true,
            composed: true
        }));
    };
    /**
   * Handles the dragover event of the dropzone.
   *
   * @param {*} evt - The event object.
   */ #handleDragOver = (evt)=>{
        evt.preventDefault();
        if (this.disabled) {
            evt.dataTransfer.dropEffect = "none";
            return;
        }
        evt.dataTransfer.dropEffect = "copy";
        if (this.#dropzoneEl) {
            this.#dropzoneEl.classList.add("dropzone--dragover");
            this.#dropzoneEl.part.add("dropzone--dragover");
        }
        this.dispatchEvent(new Event(`${$862aa3736b0514bc$var$COMPONENT_NAME}-dragover`, {
            bubbles: true,
            composed: true
        }));
    };
    /**
   * Handles the dragleave event of the dropzone.
   */ #handleDragLeave = ()=>{
        if (this.disabled) return;
        if (this.#dropzoneEl) {
            this.#dropzoneEl.classList.remove("dropzone--dragover");
            this.#dropzoneEl.part.remove("dropzone--dragover");
        }
        this.dispatchEvent(new Event(`${$862aa3736b0514bc$var$COMPONENT_NAME}-dragleave`, {
            bubbles: true,
            composed: true
        }));
    };
    /**
   * Handles the drop event of the dropzone.
   *
   * @param {*} evt - The event object.
   */ #handleDrop = async (evt)=>{
        if (this.disabled) return;
        evt.preventDefault();
        if (this.#dropzoneEl) {
            this.#dropzoneEl.classList.remove("dropzone--dragover");
            this.#dropzoneEl.part.remove("dropzone--dragover");
        }
        try {
            this.#handleFilesSelect(await (0, $f31161edf38949e9$export$6d52664cd15c442)(evt));
        } catch (error) {
            this.dispatchEvent(new CustomEvent(`${$862aa3736b0514bc$var$COMPONENT_NAME}-error`, {
                bubbles: true,
                composed: true,
                detail: {
                    error: error
                }
            }));
        }
    };
    /**
   * Handles the click event of the dropzone.
   */ #handleClick = ()=>{
        if (this.disabled) return;
        this.#fileInput?.click();
    };
    /**
   * Handles the keyup event of the dropzone.
   *
   * @param {*} evt - The event object.
   */ #handleKeyUp = (evt)=>{
        if (this.disabled) return;
        if (evt.key === " " || evt.key === "Enter") this.#fileInput?.click();
    };
    /**
   * Handles the selection of files.
   *
   * @param {File[]} files - The files to handle.
   */ #handleFilesSelect(files) {
        if (!Array.isArray(files) || !files.length) return;
        const acceptedFiles = [];
        const rejectedFiles = [];
        const filesLength = files.length;
        // If the component is not in multiple mode, reject all files.
        if (!this.multiple && filesLength > 1) for (const file of files)rejectedFiles.push({
            file: file,
            errors: [
                {
                    code: $862aa3736b0514bc$var$TOO_MANY_FILES,
                    message: `Too many files selected. Only 1 file is allowed.`
                }
            ]
        });
        else if (this.multiple && filesLength > this.maxFiles) // If the component is in multiple mode, but the number of files exceeds
        // the maxFiles attribute, reject all files.
        for (const file of files)rejectedFiles.push({
            file: file,
            errors: [
                {
                    code: $862aa3736b0514bc$var$TOO_MANY_FILES,
                    message: `Too many files selected. Only ${this.maxFiles} ${this.maxFiles > 1 ? "files are" : "file is"} allowed.`
                }
            ]
        });
        else // Validate each file. If it's valid, add it to the accepted files array,
        // otherwise add it to the rejected files array.
        for (const file of files){
            const fileHasValidType = (0, $38f222170fd4d21a$export$7c47054fed488f80)(file, this.accept);
            const fileExceedsMaxSize = file.size > this.maxSize;
            const fileIsSmallerThanMinSize = file.size < this.minSize;
            if (fileHasValidType && !fileExceedsMaxSize && !fileIsSmallerThanMinSize) acceptedFiles.push(file);
            else {
                const errors = [];
                if (!fileHasValidType) errors.push({
                    code: $862aa3736b0514bc$var$INVALID_MIME_TYPE,
                    message: `File type "${file.type}" is not accepted.`
                });
                if (fileExceedsMaxSize) errors.push({
                    code: $862aa3736b0514bc$var$FILE_TOO_LARGE,
                    message: `File size ${file.size} exceeds the maximum size of ${this.maxSize}.`
                });
                if (fileIsSmallerThanMinSize) errors.push({
                    code: $862aa3736b0514bc$var$FILE_TOO_SMALL,
                    message: `File size ${file.size} is smaller than the minimum size of ${this.minSize}.`
                });
                rejectedFiles.push({
                    file: file,
                    errors: errors
                });
            }
        }
        this.dispatchEvent(new CustomEvent(`${$862aa3736b0514bc$var$COMPONENT_NAME}-drop`, {
            bubbles: true,
            composed: true,
            detail: {
                acceptedFiles: acceptedFiles,
                rejectedFiles: rejectedFiles
            }
        }));
        if (acceptedFiles.length > 0) this.dispatchEvent(new CustomEvent(`${$862aa3736b0514bc$var$COMPONENT_NAME}-drop-accepted`, {
            bubbles: true,
            composed: true,
            detail: {
                acceptedFiles: acceptedFiles
            }
        }));
        if (rejectedFiles.length > 0) this.dispatchEvent(new CustomEvent(`${$862aa3736b0514bc$var$COMPONENT_NAME}-drop-rejected`, {
            bubbles: true,
            composed: true,
            detail: {
                rejectedFiles: rejectedFiles
            }
        }));
        if (this.#fileInput) this.#fileInput.value = this.#fileInput.defaultValue;
    }
    /**
   * Opens the file dialog programmatically.
   */ openFileDialog() {
        if (this.disabled) return;
        this.#fileInput?.click();
    }
    /**
   * This is to safe guard against cases where, for instance, a framework may have added the element to the page and set a
   * value on one of its properties, but lazy loaded its definition. Without this guard, the upgraded element would miss that
   * property and the instance property would prevent the class property setter from ever being called.
   *
   * https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *
   * @param {'accept' | 'disabled' | 'maxFiles' | 'maxSize' | 'minSize' | 'multiple' | 'autoFocus' | 'noStyle'} prop - The property name to upgrade.
   */ #upgradeProperty(prop) {
        /** @type {any} */ const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    /**
   * Defines a custom element with the given name.
   * The name must contain a dash (-).
   *
   * @param {string} [elementName='files-dropzone'] - The name of the custom element.
   * @example
   *
   * FilesDropzone.defineCustomElement('my-dropzone');
   */ static defineCustomElement(elementName = $862aa3736b0514bc$var$COMPONENT_NAME) {
        if (typeof window !== "undefined" && !window.customElements.get(elementName)) window.customElements.define(elementName, $862aa3736b0514bc$export$6ccd1735166caad9);
    }
}


(0, $862aa3736b0514bc$export$6ccd1735166caad9).defineCustomElement();


export {$862aa3736b0514bc$export$6ccd1735166caad9 as FilesDropzone};
//# sourceMappingURL=files-dropzone-defined.js.map
